import type { Action } from 'redux';
import { TIKTOK_MACHINE_NAME } from '../../../../../../../shared/constants';
import dash_api from '../../../../../main/support/dash_api';
import type { Advertiser } from '../../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { TikTokAdvertisersPayload } from '../TikTok.types';

const GetTikTokAdvertisers = new ReduxAsyncAction<'GET_TIKTOK_ADVERTISERS', void, TikTokAdvertisersPayload>(
  'GET_TIKTOK_ADVERTISERS'
);
GetTikTokAdvertisers.registerRequest(async () => {
  const { data }: { data: Advertiser[] } = await dash_api.get(`/v1/tiktok/advertisers?machine_name=${TIKTOK_MACHINE_NAME}`);
  return {
    advertisers: data,
  };
});
export const GET_TIKTOK_ADVERTISERS = GetTikTokAdvertisers.actionNamespaceConstants;
export const getTikTokAdvertisers = GetTikTokAdvertisers.request;

export type GetTikTokAdvertisersAction = Action<
  typeof GET_TIKTOK_ADVERTISERS.response | typeof GET_TIKTOK_ADVERTISERS.request
> & {
  data: TikTokAdvertisersPayload;
};
